/**
 * Bankszámlaszámot egészít ki, validál
 * @author adamcsabi
 */

var FINANCIAL_NUMBER_MAXLENGTH = 26;
var FITPATTERN = /^[0-9]{8}-[0-9]{8}(-[0-9]{8})?$/;

export default function (app) {
	app.directive('financialAccount', function () {
		return {
			scope: {
				financialAccountNumber: '='
			},
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {

				let setValidity = function (value) {
					return ctrl.$setValidity('financialAccountNumberFormat', FITPATTERN.test(value));
				};

				scope.$watch('financialAccountNumber', function (newValue, oldValue) {

					if (newValue && oldValue) {
						if (newValue.length == 8 && oldValue.length == 7) {
							scope.financialAccountNumber = newValue + '-';
						} else if (newValue.length == 18 && oldValue.length == 17) {
							var last = newValue.slice(newValue.length - 1);
							scope.financialAccountNumber = newValue.slice(0, -1) + '-' + last;
						} else if (newValue.length == 18 && oldValue.length == 19 || newValue.length == 8 && oldValue.length == 9) {
							scope.financialAccountNumber = newValue.slice(0, -1);
						}
					}
					if (newValue && newValue.length > FINANCIAL_NUMBER_MAXLENGTH) {
						scope.financialAccountNumber = oldValue;
					}

					if (scope.financialAccountNumber) {
						if (scope.financialAccountNumber && scope.financialAccountNumber.hasOwnProperty('ID')) {
							setValidity(scope.financialAccountNumber.ID);
						} else if (scope.financialAccountNumber && scope.financialAccountNumber.hasOwnProperty('GiroAccountNumber')) {
							setValidity(scope.financialAccountNumber.GiroAccountNumber);
						} else {
							setValidity(scope.financialAccountNumber);
						}
					}

				});
			}
		};
	});
}
